import { apiService } from '../Config/api.service';

let cachedUser = null;
let cachedUserPromise = null;

export const getStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user') || '{}');
    } catch (error) {
        return {};
    }
};

export const fetchCurrentUser = async (force = false) => {
    if (!force && cachedUser) {
        return cachedUser;
    }

    if (!force && cachedUserPromise) {
        return cachedUserPromise;
    }

    cachedUserPromise = apiService
        .getElement('/user')
        .then((response) => {
            cachedUser = response?.data?.user || {};
            cachedUserPromise = null;
            return cachedUser;
        })
        .catch(() => {
            cachedUserPromise = null;
            return getStoredUser();
        });

    return cachedUserPromise;
};

export const resetCachedUser = () => {
    cachedUser = null;
    cachedUserPromise = null;
};

export const getUserRole = (user = getStoredUser()) => user?.role || 'user';

// 'compta' et 'user' (Client Cabinet) sont hors hiérarchie : niveau 0, en consultation seule.
const ROLE_LEVELS = { user: 0, compta: 0, rh: 1, admin: 2, superadmin: 3 };

const hasMinRole = (user, minRole) =>
    (ROLE_LEVELS[getUserRole(user)] ?? 0) >= (ROLE_LEVELS[minRole] ?? 0);

const resolveUser = (user) => user || getStoredUser();

export const canAccessSettings      = (user) => hasMinRole(resolveUser(user), 'admin');
export const canManageCompany       = (user) => hasMinRole(resolveUser(user), 'admin');
export const canCreateCompany       = (user) => {
    const resolvedUser = resolveUser(user);
    if (hasMinRole(resolvedUser, 'superadmin')) return true;
    if (!hasMinRole(resolvedUser, 'admin')) return false;
    const activeId = resolvedUser?.company_active?.id;
    const activeInList = (resolvedUser?.company_ids || []).find(c => c.id === activeId);
    return activeInList?.parent_id === 1;
};
export const canCreateUser          = (user) => hasMinRole(resolveUser(user), 'admin');
export const canCloseMonth          = (user) => hasMinRole(resolveUser(user), 'rh');
export const canDeleteSettlement    = (user) => hasMinRole(resolveUser(user), 'admin');
export const canManageAccountingSetup = (user) => hasMinRole(resolveUser(user), 'admin');
export const canManageUsers         = (user) => hasMinRole(resolveUser(user), 'admin');
export const canManageContractExpiration = (user) => hasMinRole(resolveUser(user), 'rh');

// Rôles en consultation seule : 'compta' (Pôle Comptabilité) et 'user' (Client Cabinet).
export const isAccountant           = (user) => getUserRole(resolveUser(user)) === 'compta';
export const isReadOnlyUser         = (user) => getUserRole(resolveUser(user)) === 'user';
export const canEditHrData          = (user) => hasMinRole(resolveUser(user), 'rh');
export const canViewAccountingJournal = (user) => canEditHrData(user) || isAccountant(user);
export const canViewEmployees       = (user) => !isAccountant(user);
export const canViewFinancialStatements = (user) => canEditHrData(user);
